import { createContext, useContext } from "react";
import type { AudioState, NowPlaying } from "../types";

interface AudioContextType {
  state: AudioState;
  audioRef: React.RefObject<HTMLAudioElement | null>;
  selectStream: (id: string) => void;
  togglePlay: () => void;
  setVolume: (v: number) => void;
  toggleMute: () => void;
  nowPlaying: NowPlaying | null;
}

export const AudioContext = createContext<AudioContextType | null>(null);

export function useAudio() {
  const ctx = useContext(AudioContext);
  if (!ctx) throw new Error("useAudio must be used within AudioProvider");
  return ctx;
}
